// extracted by mini-css-extract-plugin
export default {"container":"_3vO6K","title":"_3lWQO","text":"_1ItT3","image":"_1spDR"};